
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","stroke":"#6C7684","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M13.75 15.75H11a2 2 0 01-2-2V11a2 2 0 012-2h2.75a2 2 0 012 2v2.75a2 2 0 01-2 2zM25 15.75h-2.75a2 2 0 01-2-2V11a2 2 0 012-2H25a2 2 0 012 2v2.75a2 2 0 01-2 2zM13.75 27H11a2 2 0 01-2-2v-2.75a2 2 0 012-2h2.75a2 2 0 012 2V25a2 2 0 01-2 2zM25 27h-2.75a2 2 0 01-2-2v-2.75a2 2 0 012-2H25a2 2 0 012 2V25a2 2 0 01-2 2z","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    